import PropTypes from 'prop-types';
import React, { useState } from 'react';
import TextButton from '../../../../../atomic/buttons/textButton/TextButton';
import { determineTradeTypes } from './determineTradeTypes';
import style from './QuickTradeModule.module.css';
import { colors } from '../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { Body3, fontSizes } from '../../../../../atomic/text/Text';
import { userTrade } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/userTrade';
import { MultiSwitch } from '../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { BoxInput } from '../../../../../atomic/inputs/boxInput/BoxInput';

function QuickTradeModule({ tradePlanId }) {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const orderTypes = determineTradeTypes(tradePlan);
  const symbol = tradePlan.positionSymbol;
  const [tradeType, setTradeType] = useState('MKT');
  const [qty, setQty] = useState(0);
  const [limitPrice, setLimitPrice] = useState(0);

  return (
    <div className={style.container} style={{ backgroundColor: colors.grey }}>
      {/* <Body2 color={colors.lightGrey} fontWeight={700}>
        Quick Trade
      </Body2> */}

      <MultiSwitch
        margin="0 auto"
        labels={['Market', 'Limit']}
        values={['MKT', 'LMT']}
        controlledValue={tradeType}
        setValue={setTradeType}
      />
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Quantity
          </Body3>
          <BoxInput
            value={qty}
            setValue={(value) => setQty(value)}
            backgroundColor={colors.grey}
            fontSize={fontSizes.body2}
            width="60px"
            height="20px"
            direction="left"
            symbol="#"
          />
        </div>
        <div className={style.inputAndLabel}>
          <Body3
            fontWeight={700}
            color={tradeType === 'MKT' ? 'grey' : colors.lightGrey}
          >
            Limit
          </Body3>
          <BoxInput
            disabled={tradeType === 'MKT'}
            value={limitPrice}
            setValue={(value) => setLimitPrice(value)}
            backgroundColor={colors.grey}
            fontSize={fontSizes.body2}
            width="60px"
            height="20px"
            direction="left"
            symbol="$"
          />
        </div>
      </div>
      <div className={style.buttons}>
        {orderTypes.map((type) => (
          <TextButton
            clickHandler={() => {
              if (tradeType === 'MKT' || limitPrice !== 0) {
                userTrade(
                  tradePlan.id,
                  type.val,
                  qty,
                  tradeType,
                  limitPrice,
                  symbol
                );
              }
            }}
            disabled={
              !tradePlan.inPosition || (tradeType === 'LMT' && limitPrice == 0)
            }
            fontSize="small"
            width="23%"
            key={type.val}
            backgroundColor={
              tradePlan.inPosition && !(tradeType === 'LMT' && limitPrice == 0)
                ? type.val === 'BTO' || type.val === 'STO'
                  ? colors.green
                  : colors.red
                : colors.grey
            }
          >
            {type.val}
          </TextButton>
        ))}
      </div>
    </div>
  );
}

QuickTradeModule.propTypes = {
  tradePlanId: PropTypes.string,
};

export default QuickTradeModule;
